// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-total {
  display: inline-block;
  font-size: 13px;
  font-weight: bold;
  width: calc(50% - 20px);
  height: 40px;
  margin: 0 10px 0;
}

.table-container {
  overflow: auto;
  border-top: 1px solid rgb(228, 225, 225);
  min-height: 200px;
  min-width: 100%;
}
.table-container .contact a {
  padding: 2px 10px;
  border-radius: 10px;
  background-color: rgba(114, 103, 240, 0.1019607843);
}
.table-container table {
  min-width: 100%;
  height: fit-content;
  table-layout: fixed;
}
.table-container table th,
.table-container table td {
  white-space: nowrap;
  padding: 0 20px;
}
.table-container table thead {
  background-color: #f3f2f7;
  height: 35px;
  border-bottom: 1px solid rgb(228, 225, 225);
  color: #8d8a98;
}
.table-container table thead th {
  text-transform: uppercase;
  font-size: 13px;
}
.table-container table thead th .form-check-input:checked {
  background-color: #7367f0;
  border-color: #7367f0;
}
.table-container table thead th:first-child {
  padding: 0 20px;
}
.table-container table tbody {
  /* Default styles for statuses */
  /* Status-specific classes */
}
.table-container table tbody td {
  font-size: 14px;
}
.table-container table tbody td a {
  color: var(--headerFont) !important;
}
.table-container table tbody .status {
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  font-weight: bold;
}
.table-container table tbody .not {
  background-color: #6c757d; /* Gray */
  color: #ffffff;
}
.table-container table tbody .started {
  background-color: #17a2b8; /* Cyan */
  color: #ffffff;
}
.table-container table tbody .preparing {
  background-color: #ffc107; /* Yellow */
  color: #000000;
}
.table-container table tbody .finished {
  background-color: #28a745; /* Green */
  color: #ffffff;
}
.table-container table tbody .in {
  background-color: #007bff; /* Blue */
  color: #ffffff;
}
.table-container table tbody .complete {
  background-color: #20c997; /* Teal */
  color: #ffffff;
}
.table-container table tbody .cancel {
  background-color: #dc3545; /* Red */
  color: #ffffff;
}
.table-container table tbody .deleted {
  background-color: #343a40; /* Dark Gray */
  color: #ffffff;
}
.table-container table tbody .close {
  background-color: red;
  color: #fff;
}
.table-container table tbody .open {
  background-color: green;
  color: #fff;
}
.table-container table tbody .soon {
  background-color: yellow;
  color: #000;
}
.table-container table tbody .busy {
  background-color: blue;
  color: #fff;
}
.table-container table tbody .status button {
  background-color: var(--headerFont);
  color: #fff;
  font-weight: bold;
  width: 100px;
}
.table-container table tbody .status:hover button,
.table-container table tbody .status:focus button {
  background-color: rgba(15, 127, 62, 0.6235294118) !important;
}
.table-container table tbody tr {
  border-bottom: 1px solid rgba(238, 238, 238, 0.753);
  height: 65px;
}
.table-container table tbody tr .name {
  padding: 0 15px;
}
.table-container table tbody tr .name h6 {
  color: var(--headerFont);
  margin-bottom: 0;
  font-size: 16px;
  font-weight: 700;
}
.table-container table tbody tr .name span {
  display: flex;
  align-items: center;
}
.table-container table tbody tr .name span div img {
  display: inline;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  object-fit: cover;
  margin-left: 10px;
}
.table-container table tbody tr .name span div:last-child {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.table-container table tbody tr .name span div:last-child p {
  margin: 2px 0;
  font-size: 13px;
}
.table-container table tbody tr td a {
  text-decoration: none;
  color: var(--headerFont);
}

.dark .table-container {
  border-top: 1px solid #38393a;
}
.dark .table-container table thead {
  color: var(--darkFont);
  background-color: #151515;
  border-top: 1px solid #38393a;
  border-bottom: 1px solid #38393a;
}
.dark .table-container table tbody tr {
  border-bottom: 1px solid #38393a;
  color: var(--darkFont);
}
.dark .table-container table tbody td a {
  color: var(--darkFont) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/table.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AACA;EACE,cAAA;EACA,wCAAA;EACA,iBAAA;EACA,eAAA;AAEF;AACI;EACE,iBAAA;EACA,mBAAA;EACA,mDAAA;AACN;AAEE;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AACI;;EAEE,mBAAA;EACA,eAAA;AACN;AACI;EACE,yBAAA;EACA,YAAA;EACA,2CAAA;EACA,cAAA;AACN;AAAM;EACE,yBAAA;EACA,eAAA;AAER;AADQ;EACE,yBAAA;EACA,qBAAA;AAGV;AAAM;EACE,eAAA;AAER;AACI;EAQE,gCAAA;EASA,4BAAA;AAdN;AAFM;EACE,eAAA;AAIR;AAHQ;EACE,mCAAA;AAKV;AAAM;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAER;AAEM;EACE,yBAAA,EAAA,SAAA;EACA,cAAA;AAAR;AAGM;EACE,yBAAA,EAAA,SAAA;EACA,cAAA;AADR;AAIM;EACE,yBAAA,EAAA,WAAA;EACA,cAAA;AAFR;AAKM;EACE,yBAAA,EAAA,UAAA;EACA,cAAA;AAHR;AAMM;EACE,yBAAA,EAAA,SAAA;EACA,cAAA;AAJR;AAOM;EACE,yBAAA,EAAA,SAAA;EACA,cAAA;AALR;AAQM;EACE,yBAAA,EAAA,QAAA;EACA,cAAA;AANR;AASM;EACE,yBAAA,EAAA,cAAA;EACA,cAAA;AAPR;AAUM;EACE,qBAAA;EACA,WAAA;AARR;AAUM;EACE,uBAAA;EACA,WAAA;AARR;AAUM;EACE,wBAAA;EACA,WAAA;AARR;AAUM;EACE,sBAAA;EACA,WAAA;AARR;AAUM;EACE,mCAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AARR;AAUM;;EAEE,4DAAA;AARR;AAUM;EACE,mDAAA;EACA,YAAA;AARR;AASQ;EACE,eAAA;AAPV;AAQU;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AANZ;AAQU;EACE,aAAA;EACA,mBAAA;AANZ;AAQc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AANhB;AASY;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAPd;AAQc;EACE,aAAA;EACA,eAAA;AANhB;AAYU;EACE,qBAAA;EACA,wBAAA;AAVZ;;AAkBE;EACE,6BAAA;AAfJ;AAiBM;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;AAfR;AAkBQ;EACE,gCAAA;EACA,sBAAA;AAhBV;AAmBU;EACE,iCAAA;AAjBZ","sourcesContent":[".vendor-total {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: bold;\n  width: calc(50% - 20px);\n  height: 40px;\n  margin: 0 10px 0;\n}\n.table-container {\n  overflow: auto;\n  border-top: 1px solid rgb(228, 225, 225);\n  min-height: 200px;\n  min-width: 100%;\n\n  .contact {\n    a {\n      padding: 2px 10px;\n      border-radius: 10px;\n      background-color: #7267f01a;\n    }\n  }\n  table {\n    min-width: 100%;\n    height: fit-content;\n    table-layout: fixed;\n    th,\n    td {\n      white-space: nowrap;\n      padding: 0 20px;\n    }\n    thead {\n      background-color: #f3f2f7;\n      height: 35px;\n      border-bottom: 1px solid rgb(228, 225, 225);\n      color: #8d8a98;\n      th {\n        text-transform: uppercase;\n        font-size: 13px;\n        .form-check-input:checked {\n          background-color: #7367f0;\n          border-color: #7367f0;\n        }\n      }\n      th:first-child {\n        padding: 0 20px;\n      }\n    }\n    tbody {\n      td {\n        font-size: 14px;\n        a {\n          color: var(--headerFont) !important;\n        }\n      }\n\n      /* Default styles for statuses */\n      .status {\n        padding: 10px;\n        border-radius: 5px;\n        text-align: center;\n        display: inline-block;\n        font-weight: bold;\n      }\n\n      /* Status-specific classes */\n      .not {\n        background-color: #6c757d; /* Gray */\n        color: #ffffff;\n      }\n\n      .started {\n        background-color: #17a2b8; /* Cyan */\n        color: #ffffff;\n      }\n\n      .preparing {\n        background-color: #ffc107; /* Yellow */\n        color: #000000;\n      }\n\n      .finished {\n        background-color: #28a745; /* Green */\n        color: #ffffff;\n      }\n\n      .in {\n        background-color: #007bff; /* Blue */\n        color: #ffffff;\n      }\n\n      .complete {\n        background-color: #20c997; /* Teal */\n        color: #ffffff;\n      }\n\n      .cancel {\n        background-color: #dc3545; /* Red */\n        color: #ffffff;\n      }\n\n      .deleted {\n        background-color: #343a40; /* Dark Gray */\n        color: #ffffff;\n      }\n\n      .close {\n        background-color: red;\n        color: #fff;\n      }\n      .open {\n        background-color: green;\n        color: #fff;\n      }\n      .soon {\n        background-color: yellow;\n        color: #000;\n      }\n      .busy {\n        background-color: blue;\n        color: #fff;\n      }\n      .status button {\n        background-color: var(--headerFont);\n        color: #fff;\n        font-weight: bold;\n        width: 100px;\n      }\n      .status:hover button,\n      .status:focus button {\n        background-color: #0f7f3e9f !important;\n      }\n      tr {\n        border-bottom: 1px solid rgba(238, 238, 238, 0.753);\n        height: 65px;\n        .name {\n          padding: 0 15px;\n          h6 {\n            color: var(--headerFont);\n            margin-bottom: 0;\n            font-size: 16px;\n            font-weight: 700;\n          }\n          span {\n            display: flex;\n            align-items: center;\n            div {\n              img {\n                display: inline;\n                width: 40px;\n                height: 40px;\n                border-radius: 5px;\n                object-fit: cover;\n                margin-left: 10px;\n              }\n            }\n            div:last-child {\n              margin: 0 5px;\n              display: flex;\n              justify-content: center;\n              flex-direction: column;\n              p {\n                margin: 2px 0;\n                font-size: 13px;\n              }\n            }\n          }\n        }\n        td {\n          a {\n            text-decoration: none;\n            color: var(--headerFont);\n          }\n        }\n      }\n    }\n  }\n}\n.dark {\n  .table-container {\n    border-top: 1px solid #38393a;\n    table {\n      thead {\n        color: var(--darkFont);\n        background-color: #151515;\n        border-top: 1px solid #38393a;\n        border-bottom: 1px solid #38393a;\n      }\n      tbody {\n        tr {\n          border-bottom: 1px solid #38393a;\n          color: var(--darkFont);\n        }\n        td {\n          a {\n            color: var(--darkFont) !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
